export const DeferrableProducts = ['FNB Funeral Plan'];
